export default {
  modalTitle: 'Redimensionar componente',
  widthLabel: 'Largura',
  widthPlaceholder: 'Default',
  heightLabel: 'Altura',
  heightPlaceholder: 'Default',
  widthSize: {
    SMALL: '2 Colunas',
    MID: '3 Colunas',
    LARGE: '4 Colunas',
    COL5: '5 Colunas',
    XLARGE: '6 Colunas',
    COL7: '7 Colunas',
    COL8: '8 Colunas',
    COL9: '9 Colunas',
    COL10: '10 Colunas',
    COL11: '11 Colunas',
    COL12: '12 Colunas',
  },
  heightSize: {
    SMALL: 'Pequeno',
    MID: 'Médio',
    LARGE: 'Grande',
    XLARGE: 'Extra grande',
  },
};
